// Not part of the ES2023 lib, but present in every runtime this package runs in.
declare const TextEncoder: new () => { encode(text: string) : Uint8Array };
declare const TextDecoder: new () => { decode(bytes: Uint8Array) : string };

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function concatBytes(parts: readonly Uint8Array[]) : Uint8Array {
    let length = 0;
    for (const part of parts) {
        length += part.length;
    }
    const result = new Uint8Array(length);
    let offset = 0;
    for (const part of parts) {
        result.set(part, offset);
        offset += part.length;
    }
    return result;
}

export const utf8Encode = (text: string) : Uint8Array => encoder.encode(text);
export const utf8Decode = (bytes: Uint8Array) : string => decoder.decode(bytes);

/** One character per byte: for protocol text, where a byte must never be merged or replaced. */
export function latin1Decode(bytes: Uint8Array) : string {
    let text = '';
    for (let offset = 0; offset < bytes.length; offset += 8192) {
        text += String.fromCharCode(...bytes.subarray(offset, offset + 8192));
    }
    return text;
}

export function bytesEqual(a: Uint8Array, b: Uint8Array) : boolean {
    return a.length === b.length && a.every((byte, i) => byte === b[i]);
}
